<template>
  <div class="contactUsComponent-container">
    <table></table>
    <div class="allTitle">联系我们</div>
    <div class="contactUsBottom">
      <div class="iconBackground"></div>
      <div class="toptitle">
        如需了解详情与商务合作，您可留言咨询，我们的咨询顾问将为您提供更多信息与资料。
      </div>
      <div class="informationBox">
        <div class="boxitem">
          <div class="itemicon">
            <svg class="icon svg-icon" aria-hidden="true">
              <use xlink:href="#icon-dianhua"></use>
            </svg>
          </div>
          <div class="itemcontent">021-65102886</div>
        </div>
        <!-- <div class="boxitem">
          <div class="itemicon">
            <svg class="icon svg-icon" aria-hidden="true">
              <use xlink:href="#icon-youxiang"></use>
            </svg>
          </div>
          <div class="itemcontent">PeterHan@mobsa.net</div>
        </div> -->
        <div class="boxitem">
          <div class="itemicon">
            <svg class="icon svg-icon" aria-hidden="true">
              <use xlink:href="#icon-dizhi"></use>
            </svg>
          </div>
          <div class="itemcontent">
            上海市杨浦区黄兴路2005弄<br />杨浦科技大厦2号楼702室
          </div>
        </div>
      </div>
      <div class="sendBox">
        <div class="topBox">
          <div class="boxTop">
            <input type="text" name="" id="" placeholder="联系人" v-model="name" />
          </div>
          <div class="boxTop">
            <input type="text" name="" id="" placeholder="联系方式" v-model="phone" />
          </div>
        </div>
        <div class="centerBox">
          <textarea
            class="selftextarea"
            name=""
            id=""
            cols="30"
            rows="10"
            placeholder="您想咨询的内容"
            v-model="content"
          ></textarea>
        </div>
        <div class="sendBottom" @click="addInformation">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { addInformation } from '../api/index'
export default {
  name: "contactUsComponent",
  data() {
    return {
      name:undefined,
      phone:undefined,
      content:undefined
    };
  },
  methods:{
    addInformation(){
      console.log(this.name,this.phone,this.content)
      let data = {
        name:this.name,
        phone:this.phone,
        content:this.content
      }
      addInformation(data).then(res=>{
        if(res.code === 0){
          alert('提交成功，我们技术支持会尽快与您联系')
          this.name = undefined
          this.phone = undefined
          this.content = undefined
        }else{
          alert('提交失败，请检查您的输入是否有误')
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
input,
textarea {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); //去除移动端点击的背景色
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #c5c5c5;
}
textarea:-moz-placeholder,
input:-moz-placeholder {
  color: #c5c5c5;
}

textarea::-moz-placeholder,
input::-moz-placeholder {
  color: #c5c5c5;
}

textarea:-ms-input-placeholder,
input:-ms-input-placeholder {
  color: #c5c5c5;
}
.contactUsComponent-container {
  height: 388px;
  color: #fff;
  .contactUsBottom {
    height: 282px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    .iconBackground {
      width: 170px;
      height: 80px;
      background: url("../assets/pageImg/contentUsLOGO.png") center no-repeat;
      background-size: 100%;
    }
    .toptitle {
      display: none;
    }
    .informationBox {
      .boxitem{
        display: flex;
        flex-flow:row nowrap;
        margin-top:10px;
        .itemicon{
          height:20px;
          width:20px;
          margin-right:10px;
        }
        .itemcontent{

        }
      }
    }
    .sendBox {
      width: 470px;
      position: relative;
      .topBox {
        margin-bottom: 13px;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        .boxTop {
          width: 220px;
          height: 32px;
          padding-left: 10px;
          box-sizing: border-box;
          background: #fff;
          input {
            width: 100%;
            height: 100%;
            border: none;
            outline: medium;
          }
        }
      }
    }
    .centerBox {
      width: 470px;
      .selftextarea {
        padding: 10px;
        box-sizing: border-box;
        width: 100%;
        max-height: 95px;
        border: none;
        outline: medium;
        resize: none;
      }
    }
    .sendBottom {
      color: #515151;
      text-align: center;
      line-height: 25px;
      margin-left: calc(100% - 72px);
      margin-top: 10px;
      background: #fff;
      width: 72px;
      height: 25px;
      border-radius: 5px;
      font-size:13px;
    }
  }
}

@media screen and (max-width: 767px) {
  .contactUsComponent-container {
    height: 470px;
    .contactUsBottom {
      height: 380px;
      flex-flow: column nowrap;
      align-items: flex-start;
      .iconBackground {
        // background: ;
        display: none;
      }
      .toptitle {
        display: block;
      }
      .informationBox {
      }
      .sendBox {
        width: 100%;
        // margin-bottom:8px;
        .topBox {
          flex-flow: column nowrap;

          .boxTop {
            width: 100%;
            margin-top: 8px;
            input {
              width: 100%;
            }
          }
        }
      }
      .centerBox {
        width: 100%;
        // height:180px;
        .selftextarea {
          width: 100%;
        }
      }
      .sendBottom {
        margin: auto;
        width: 66%;
        margin-top: 15px;
        // box-sizing: border-box;
      }
    }
  }
}
</style>